import React from 'react';
import Legal from '../Legal';


export default function TermsModal(props, { handler }) {
    const [showModal, setShowModal] = React.useState(false);

    return (
        <>
            <span onClick={() => setShowModal(true)} className="text-blue-700">Terms & conditions</span>
            {showModal ? (
                <div>
                    <div className="z-50 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto"
                        id="exampleModalScrollable" tabIndex="-1" aria-labelledby="exampleModalScrollableLabel" aria-hidden="true">
                        <div className="sm:h-[calc(100%-3rem)] max-w-lg my-6 mx-auto relative w-auto pointer-events-none">
                            <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                                {/*content*/}
                                <div className="flex-auto overflow-y-auto text-black relative p-4">
                                    <Legal></Legal>
                                </div>
                                <div className="relative p-6 flex-auto">
                                    {props.color ? (
                                        <button
                                            style={{ backgroundColor: props.color }}
                                            className="w-full text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                            type="button"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Close
                                        </button>
                                    ) : (
                                        <button
                                            className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                            type="button"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Close
                                        </button>
                                    )}


                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black flex-1"></div>
                </div>
            ) : null}
        </>
    );
}